import { createSlice } from '@reduxjs/toolkit';
import { isValidEnumValue } from '../../helpers/utility';
import { SidebarContext, SidebarView, SidebarMessageStatus } from './types';

const { CLAIMS } = SidebarContext;
const { LIST, DETAILS, SEND_MESSAGE } = SidebarView;
const { CREATE } = SidebarMessageStatus;

const initialState = {
  sidebarContext: CLAIMS,
  sidebarView: LIST,
  messageStatus: null,
  isSidebarOpen: false
};

const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    setSidebarState: (state, action) => {
      state.sidebarContext = action.payload.sidebarContext ?? state.sidebarContext;
      state.sidebarView = action.payload.sidebarView;
      state.messageStatus = action.payload.messageStatus ?? null;
    },
    setSidebarContext: (state, action) => {
      state.sidebarContext = action.payload;
    },
    setSidebarToList: (state) => {
      state.sidebarView = LIST;
      state.messageStatus = null;
    },
    setSidebarToDetails: (state) => {
      state.sidebarView = DETAILS;
      state.messageStatus = null;
    },
    setSidebarToSendMessage: (state) => {
      state.sidebarView = SEND_MESSAGE;
      state.messageStatus = CREATE;
    },
    toggleSidebar: (state) => {
      state.isSidebarOpen = !state.isSidebarOpen;
    },
    closeSidebar: (state) => {
      state.isSidebarOpen = false;
    },
    setSidebarView: (state, action) => {
      state.sidebarView = action.payload;
    },
    setSidebarMessageStatus: (state, action) => {
      if (!isValidEnumValue(action.payload, SidebarMessageStatus)) return;
      state.messageStatus = action.payload;
    }
  }
});

export const {
  setSidebarState,
  setSidebarContext,
  setSidebarToSendMessage,
  setSidebarToList,
  setSidebarToDetails,
  toggleSidebar,
  closeSidebar,
  setSidebarView,
  setSidebarMessageStatus
} = sidebarSlice.actions;

export default sidebarSlice.reducer;
